<template>
  <a-spin :spinning="spinning">
    <ele-table
      ref="rt"
      :columns="columns"
      :table-data="data"
      :total-items="totalItems"
      :actions-type="actionsType"
      :is-full="true"
      :current-page="pageNumber"
      :hide-row-selection="true"
      @emitRefreshData="clearFilterAndRefresh"
      @emitSortData="updateSortData"
      @emitSelectChange="updateSelectChange"
      @emitOnPageChange="updatePageChange"
      @emitShowSizeChange="updateShowSizeChange"
    >
      <!-- 查询 -->
      <a-row :gutter="8">
        <a-col class="gutter-row" :span="2">
          <a-input
            v-model.trim="SearchDto.realName"
            placeholder="收款人姓名"
            allow-clear
          />
        </a-col>
        <a-col class="gutter-row" :span="3">
          <a-input
            v-model.trim="SearchDto.idCard"
            placeholder="身份证号码"
            allow-clear
          />
        </a-col>
        <a-col class="gutter-row" :span="2">
          <a-input
            v-model.trim="SearchDto.phone"
            placeholder="手机号码"
            allow-clear
          />
        </a-col>
        <a-col class="gutter-row" :span="2">
          <a-input
            v-model.trim="SearchDto.orderNo"
            placeholder="发放订单号"
            allow-clear
          />
        </a-col>
        <a-col class="gutter-row" :span="2">
          <a-select
            v-model="SearchDto.status"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
            :options="statusOptions"
            placeholder="发放状态"
            allowClear
          >
          </a-select>
        </a-col>
        <a-col class="gutter-row" :span="2">
          <a-select
            v-model="SearchDto.processStep"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
            :options="processStepOptions"
            placeholder="处理步骤"
            allowClear
          >
          </a-select>
        </a-col>
        <a-col class="gutter-row" :span="2">
          <a-select
            v-model="SearchDto.paymentType"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
            :options="payTypeOptions"
            placeholder="支付类型"
            allowClear
          >
          </a-select>
        </a-col>
        <a-col class="gutter-row" :span="4">
          <a-range-picker
            :placeholder="['支付开始时间', '支付结束时间']"
            v-model="payTimeRange"
          />
        </a-col>
        <a-col class="gutter-row" :span="2">
          <a-month-picker
            v-model="SearchDto.yearMonth"
            valueFormat="YYYY-MM"
            placeholder="所属月份"
            style="width: 100%"
          />
        </a-col>
        <a-col class="gutter-row" :span="3">
          <a-button
            type="primary"
            @click="getData()"
            v-if="isGranted('Pages.RLPaymentDetails.Query')"
          >
            {{ l("Search") }}
          </a-button>
          <a-button @click="refreshGoFirstPage"> {{ l("Reset") }}</a-button>
        </a-col>
      </a-row>
    </ele-table>
  </a-spin>
</template>
<script>
import { AppComponentBase } from "@/shared/component-base";
import { ModalComponentBase } from "@/shared/component-base";
import { ModalHelper } from "@/shared/helpers";
import { CommonServiceProxy } from "@/shared/common-service";
import { fileDownloadService } from "@/shared/utils";
import moment from "moment";
import EleTable from "@/components/ele-table";
import { AppConsts } from "@/abpPro/AppConsts";

export default {
  mixins: [AppComponentBase, ModalComponentBase],
  name: "recurringLabor-record",
  components: { EleTable },
  data() {
    return {
      spinning: false,
      selectedRowKeys: [],
      SearchDto: {
        realName: "",
        idCard: "",
        phone: "",
        orderNo: "",
        status: undefined,
        processStep: undefined,
        paymentType: undefined,
        yearMonth: undefined,
        customerId: undefined,
        companyId: undefined,
        startPayTime: undefined,
        endPayTime: undefined,
        projectIdList: [],
      },
      payTimeRange: [],
      // 总记录数
      totalItems: 0,
      // 当前页码
      pageNumber: 1,
      // 总页数
      totalPages: 1,
      // 每页显示数
      pageSizeOptions: ["10", "20", "30", "40"],
      request: {
        sorting: "CreationTime desc",
        maxResultCount: 50,
        skipCount: 0,
      },
      // 表头
      columns: [],
      actionsType: null,
      // 数据
      data: [],
      // 连续劳务支付记录状态下拉框配置
      statusOptions: [
        { value: 0, label: "待发放" },
        { value: 1, label: "已发放" },
        { value: 2, label: "发放中" },
        { value: -1, label: "发放失败" },
        { value: -2, label: "已重新发放" },
      ],
      // 连续劳务支付处理步骤下拉框配置
      processStepOptions: [
        { value: 1, label: "人员信息更新" },
        { value: 2, label: "内部转账" },
        { value: 3, label: "提交支付" },
      ],
      // 连续劳务支付类型下拉框配置
      payTypeOptions: [
        { value: 0, label: "银行卡" },
        { value: 1, label: "支付宝" },
        { value: 2, label: "积分" },
      ],
    };
  },
  created() {
    this.getData();
    this.initActionsType();
    this.initColums();
  },
  methods: {
    /**
     * 搜索框
     * @param input
     * @param option
     */
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    initColums() {
      let _this = this;
      this.columns = [
        {
          title: "请求ID",
          dataIndex: "requestId",
          key: "requestId",
          sorter: false,
          align: "center",
          width: 200,
        },
        {
          title: "第三方订单号",
          dataIndex: "thirdPartyOrderNo",
          key: "thirdPartyOrderNo",
          sorter: false,
          align: "center",
          width: 200,
        },
        {
          title: "发放批次号",
          dataIndex: "batchNo",
          key: "batchNo",
          sorter: false,
          align: "center",
        },
        {
          title: "发放订单号",
          dataIndex: "orderNo",
          key: "orderNo",
          sorter: false,
          align: "center",
        },
        {
          title: "收款人姓名",
          dataIndex: "userName",
          key: "userName",
          sorter: false,
          align: "center",
        },
        {
          title: "身份证号码",
          dataIndex: "idCard",
          key: "idCard",
          sorter: false,
          align: "center",
          width: 150,
        },
        {
          title: "手机号码",
          dataIndex: "phone",
          key: "phone",
          sorter: false,
          align: "center",
        },
        {
          title: "收款金额",
          dataIndex: "amount",
          key: "amount",
          sorter: false,
          align: "center",
        },
        {
          title: "实发金额",
          dataIndex: "payAmount",
          key: "payAmount",
          sorter: false,
          align: "center",
        },
        {
          title: "税",
          dataIndex: "tax",
          key: "tax",
          sorter: false,
          align: "center",
        },
        {
          title: "服务费",
          dataIndex: "serviceFee",
          key: "serviceFee",
          sorter: false,
          align: "center",
        },
        {
          title: "支付类型",
          dataIndex: "paymentTypeStr",
          key: "paymentType",
          sorter: false,
          align: "center",
        },
        {
          title: "收款账户",
          dataIndex: "account",
          key: "account",
          sorter: false,
          align: "center",
        },
        {
          title: "银行名称",
          dataIndex: "bankName",
          key: "bankName",
          sorter: false,
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "statusStr",
          key: "status",
          sorter: false,
          align: "center",
        },
        {
          title: "处理步骤",
          dataIndex: "processStepStr",
          key: "processStep",
          sorter: false,
          align: "center",
        },
        {
          title: "支付时间",
          dataIndex: "payTime",
          key: "payTime",
          sorter: true,
          align: "center",
          type: "time",
          width: 150,
        },
        {
          title: "客户名称",
          dataIndex: "customerName",
          key: "customerName",
          sorter: false,
          align: "center",
          width: 200,
        },
        {
          title: "签约公司",
          dataIndex: "payCompanyName",
          key: "payCompanyName",
          sorter: false,
          align: "center",
          width: 200,
        },
        {
          title: "项目名称",
          dataIndex: "projectName",
          key: "projectName",
          sorter: false,
          align: "center",
          width: 200,
        },
        {
          title: "创建时间",
          dataIndex: "creationTime",
          key: "creationTime",
          sorter: true,
          align: "center",
          type: "time",
          width: 150,
        },
        {
          title: this.l("Action"),
          dataIndex: "actions",
          fixed: "right",
          width: 100,
          scopedSlots: { customRender: "actions" },
        },
      ];
    },
    initActionsType() {
      let _this = this;
      let obj = {
        type: "RecurringLaborRecord",
        isShow: true,
        fns: {
          detailList: [
            {
              granted: this.isGranted("Pages.RLPaymentDetails.RetryPay"),
              showFunc(record) {
                return record.status == "Failed";
              },
              name: "重新发放",
              fn: (data) => {
                abp.message.confirm("是否重新发放?", "系统提示", (result) => {
                  if (result) {
                    _this.SendToService({
                      url: "/api/services/app/RecurringLabor/RetryPay",
                      method: "post",
                      data: { id: data.id },
                      success(res) {
                        _this.$notification["success"]({
                          message: "操作成功",
                        });
                        _this.getData();
                      },
                    });
                  }
                });
              },
            },
          ],
          isShow: true,
        },
      };
      this.actionsType = obj;
    },
    getData() {
      let data = { ...this.request, ...this.SearchDto };
      if (this.payTimeRange.length > 1) {
        data.startPayTime = moment(this.payTimeRange[0]).format("YYYY-MM-DD");
        data.endPayTime = moment(this.payTimeRange[1]).format("YYYY-MM-DD");
      }
      let newData = {};
      // 循环对象，判断对象中某些属性是否存在，且排除属性值为空格的属性
      for (let key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          data[key].toString().replace(/(^\s*)|(\s*$)/g, "") !== ""
        ) {
          newData[key] = data[key];
        }
      }

      this.$nextTick(() => {
        this.$refs.rt.clearData();
      });
      let _this = this;
      this.SendToService({
        url: "/api/services/app/RecurringLabor/GetRecurringLaborRecordPaged",
        method: "get",
        params: newData,
        success(res) {
          _this.data.splice(0, _this.data.length);
          _this.totalItems = res.totalCount;
          res.items.forEach((item) => _this.data.push(item));
          _this.data = res.items.map((item) => {
            return {
              ...item,
            };
          });
        },
      });
    },
    refreshGoFirstPage() {
      this.SearchDto = {
        realName: "",
        idCard: "",
        phone: "",
        orderNo: "",
        status: undefined,
        processStep: undefined,
        paymentType: undefined,
        yearMonth: "",
        customerId: undefined,
        companyId: undefined,
        startPayTime: undefined,
        endPayTime: undefined,
        projectIdList: [],
      };
      this.payTimeRange = [];
      this.pageNumber = 1;
      this.request.skipCount = 0;
      this.getData();
    },
    SendToService(opts) {
      this.spinning = true;
      let options = {
        url: this.$apiUrl + opts.url,
        method: opts.method,
        data: opts.data,
        params: opts.params,
        headers: { "Content-Type": "application/json-patch+json" },
      };
      this.$api
        .request(options)
        .then((res) => {
          this.spinning = false;
          if (opts.complete && typeof opts.complete == "function") {
            opts.complete(res);
          }
          if (res.status == 200) {
            if (opts.success && typeof opts.success == "function") {
              opts.success(res.data);
            }
          } else {
            abp.message.error(res.statusText);
          }
        })
        .catch((e) => {
          this.spinning = false;
          if (opts.complete && typeof opts.complete == "function") {
            opts.complete(e);
          }
          console.error(e);
        });
    },
    /*
        分页相关
        */
    // 情况查询条件并重新查询
    clearFilterAndRefresh() {
      this.request = {
        sorting: "CreationTime desc",
        maxResultCount: 50,
        skipCount: 0,
      };
      this.refreshGoFirstPage();
    },
    // 排序更新data
    updateSortData(newV) {
      let { columnKey, order } = newV;
      this.request.sorting = order ? `${columnKey} ${order}` : "";
      this.getData();
    },
    // table选择事件
    updateSelectChange(newV) {
      let { selectedRowKeys, selectedRows } = newV;
      this.onSelectChange(selectedRowKeys, selectedRows);
    },
    onSelectChange(keys, rows) {
      if (!!this.selectedRows) {
        this.selectedRows.splice(0, this.selectedRows.length);
        for (let i = 0; i < rows.length; i++) {
          this.selectedRows.push(rows[i]);
        }
      }
    },
    // 分页
    updatePageChange(newV) {
      let { page, pageSize } = newV;
      this.onChange(page, pageSize);
    },
    onChange(page, pageSize) {
      this.pageNumber = page;
      this.request.skipCount = (page - 1) * this.request.maxResultCount;
      this.getData();
    },
    updateShowSizeChange(newV) {
      let { current, size } = newV;
      this.showSizeChange(current, size);
    },
    showSizeChange(current, size) {
      this.pageNumber = 1;
      this.request.maxResultCount = size;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.btn--container {
  margin-top: 20px;
}

.btn--footer {
  margin-bottom: 20px;
}
.gutter-row {
  padding: 0 0 10px 5px;
}
</style>
